import React, { useCallback } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { addNotify } from 'components/Notify'

import { selectLocaleDict } from '../../features/locale/selectors'

type UseClipboardParams = {
  text: string
}

type UseClipboardReturn = {
  onCopy: () => void
}

export function useClipboard({ text }: UseClipboardParams): UseClipboardReturn {
  const locale = useSelector(selectLocaleDict, shallowEqual).common

  const onCopy = useCallback(() => {
    navigator.clipboard.writeText(text)
    addNotify(locale.copied)
  }, [locale, text])

  return { onCopy }
}
